import { newAxiosInstance } from "../axiosInstance";
import { RawBlogPost, WPBlogPost } from "../../types/blogTypes";

export interface BlogListResponse {
    results: (RawBlogPost | WPBlogPost)[];
    count: number;
    next: string | null;
    previous: string | null;
}

export const getCustomBlogs = async (page: number = 1, limit: number = 10): Promise<BlogListResponse> => {
    try {
        const response = await newAxiosInstance.get(`/blogs/?page=${page}&limit=${limit}`);

        // Handle { result: { items: [...] } } structure
        if (response.data?.result?.items) {
            return {
                results: response.data.result.items,
                count: response.data.result.items.length, // Or response.data.count if available
                next: null,
                previous: null
            };
        }

        // Handle direct array
        if (Array.isArray(response.data)) {
            return {
                results: response.data,
                count: response.data.length,
                next: null,
                previous: null
            }
        }

        // Handle { results: [...] } structure (standard pagination)
        if (response.data?.results) {
            return response.data;
        }

        // Fallback
        return {
            results: [],
            count: 0,
            next: null,
            previous: null
        };

    } catch (error) {
        console.error("Error fetching custom blogs:", error);
        throw error;
    }
};

export const getCustomBlogBySlug = async (slug: string): Promise<RawBlogPost | WPBlogPost> => {
    try {
        const response = await newAxiosInstance.get(`/blogs/${slug}`);

        // Handle { result: ... } wrapper
        if (response.data?.result) {
            return response.data.result;
        }

        return response.data;
    } catch (error) {
        console.error(`Error fetching blog detail for slug ${slug}:`, error);
        throw error;
    }
};
